const locale = process.env.REACT_APP_LOCALE ?? 'nl-BE'

type DateInput = Date | string | number | null | undefined

export const dateToLocalString = (input: DateInput): string => {
  if (input == null) return ''
  const date = input instanceof Date ? input : new Date(input)
  if (isNaN(date.getTime())) return ''
  return date.toLocaleDateString(locale)
}
